import { createSlice } from "@reduxjs/toolkit";

const initialState = {}

const productSlice = createSlice({
    name:"products",
    initialState,
    reducers:{
        increment:(state,action)=>{},
        decrement:(state,action)=>{}
    }
})

export const {increment,decrement} = productSlice.actions
export default productSlice.reducer